import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { take, tap } from 'rxjs/operators';
@Component({
  selector: 'nv-icon',
  template: require('./nv-icon.component.html'),
  styles: [require('./nv-icon.component.scss')],
  // ShadowDom is safer, but this causes issues in style injection
  encapsulation: ViewEncapsulation.None,
})
export class NvIconComponent implements OnChanges, OnInit {
  get rootElement() {
    // add .shadowRoot if using ViewEncapsulation.ShadowDom
    return this.elementRef.nativeElement; // .shadowRoot;
  }

  /**
   *
   *
   */
  @Input() name: string;

  /**
   *
   *
   */
  @Input() color: string = 'blue';

  /**
   *
   *
   */
  @Input() isInverted: boolean = false;

  svgElementRef: SVGElement;

  constructor(public elementRef: ElementRef<HTMLElement>, public iconRegistry: MatIconRegistry) {}

  ngOnInit() {
    this.setIcon(this.name);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.name && this.name) {
      this.setIcon(this.name);
    } else if (changes.color && this.color) {
      this.setColorClass(changes.color.previousValue, changes.color.currentValue);
    } else if (changes.isInverted) {
      this.setInvertedClass(this.isInverted);
    }
  }

  setIcon(name) {
    this.iconRegistry
      .getNamedSvgIcon(name)
      .pipe(
        take(1),
        tap(svg => this.setSvgElement(svg)),
      )
      .subscribe(
        null,
        (err: Error) => {
          console.error(`Error retrieving icon: ${err.message}`);
        },
        null,
      );
  }

  setSvgElement(svg: SVGElement) {
    this.clearSvgElement();
    this.rootElement.appendChild(svg);
    this.svgElementRef = this.rootElement.querySelector('svg');
    this.setColorClass(null, this.color);
    this.setInvertedClass(this.isInverted);
  }

  clearSvgElement() {
    let childCount = this.rootElement.childNodes.length;

    // Remove existing non-element child nodes and SVGs, and add the new SVG element
    while (childCount--) {
      const child = this.rootElement.childNodes[childCount];
      // 1 corresponds to Node.ELEMENT_NODE. We remove all non-element nodes in order to get rid
      // of any loose text nodes, as well as any SVG elements in order to remove any old icons.
      if (child.nodeType !== 1 || child.nodeName.toLowerCase() === 'svg') {
        this.rootElement.removeChild(child);
      }
    }
  }

  setColorClass(prevColor: string, newColor: string) {
    if (prevColor) {
      this.svgElementRef.classList.remove(prevColor.toLowerCase());
    }
    this.svgElementRef.classList.add(newColor.toLowerCase());
  }

  setInvertedClass(isInverted: boolean) {
    if (isInverted) {
      this.svgElementRef.classList.add('inverted');
    } else {
      this.svgElementRef.classList.remove('inverted');
    }
  }
}
